import * as icons from '@material-ui/icons';
export { icons as Icons };
export { default as Snackbar, useSnackbar } from 'notistack';
import React from 'react';
import { ThemeProvider, makeStyles as makeStyles$1 } from '@material-ui/styles';
import { createMuiTheme, Typography as Typography$1, withStyles, Paper, TableSortLabel, TablePagination, FormControlLabel, FormControl, InputLabel, Select, createStyles as createStyles$1, LinearProgress, Slider, makeStyles as makeStyles$2, FormHelperText, Tab, Tabs } from '@material-ui/core';
export { Collapse as FbCollapse, Fade as FbFade, Grow as FbGrow, Slide as FbSlide, Zoom as FbZoom } from '@material-ui/core';
import { __assign, __rest } from 'tslib';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
export { default as Typography } from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { makeStyles, createStyles, fade, useTheme } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import Button from '@material-ui/core/Button';
import 'typeface-roboto';
import CssBaseline from '@material-ui/core/CssBaseline';
import MenuIcon from '@material-ui/icons/Menu';
import Divider from '@material-ui/core/Divider';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Drawer from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { get } from 'lodash-es';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { BarLoader, BeatLoader, GridLoader, BounceLoader, HashLoader } from 'react-spinners';
import { getIn } from 'formik';
var BaseTheme = {
  palette: {
    primary: {
      main: '#000000',
      light: '#467abd',
      dark: '#2462a2',
      color: '#FFFFFF',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#2462a2',
      light: '#467abd',
      contrastText: '#FFFFFF'
    }
  }
};

var FbThemeProvider = function FbThemeProvider(props) {
  var theme = props.theme,
      children = props.children;
  return React.createElement(ThemeProvider, {
    theme: createMuiTheme(theme || {})
  }, children);
};

var useStyles =
/*#__PURE__*/
makeStyles(function (theme) {
  var _a, _b, _c;

  return createStyles({
    root: {
      flexGrow: 1
    },
    "default": {
      zIndex: 1300
    },
    offset: __assign(__assign({}, theme.mixins.toolbar), {
      flexGrow: 1
    }),
    grow: {
      flexGrow: 1
    },
    sidebarClosed: {
      width: 'calc(100% - 73px)',
      transition: theme.transitions.create(['all'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      left: '73px'
    },
    sidebarOpen: {
      width: 'calc(100% - 240px)',
      transition: theme.transitions.create(['all'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      left: '240px'
    },
    menuButton: {
      marginRight: theme.spacing(3)
    },
    title: (_a = {
      flexGrow: 1,
      paddingLeft: '5px',
      display: 'none',
      textAlign: 'left'
    }, _a[theme.breakpoints.up('sm')] = {
      display: 'block'
    }, _a),
    search: (_b = {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: fade(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.25)
      },
      marginLeft: 0,
      marginRight: theme.spacing(2),
      width: '100%'
    }, _b[theme.breakpoints.up('sm')] = {
      marginLeft: theme.spacing(1),
      width: 'auto'
    }, _b),
    searchIcon: {
      width: theme.spacing(7),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    inputRoot: {
      color: 'inherit'
    },
    inputInput: (_c = {
      padding: theme.spacing(1, 1, 1, 7),
      transition: theme.transitions.create('width'),
      width: '100%'
    }, _c[theme.breakpoints.up('sm')] = {
      width: 150,
      '&:focus': {
        width: 220
      }
    }, _c)
  });
});

var StyledAppBar = function StyledAppBar(props) {
  var _a;

  var sideBar = props.sideBar,
      sideBarOpen = props.sideBarOpen,
      title = props.title,
      withSearch = props.withSearch,
      barItems = props.barItems,
      withSearchPlaceholder = props.withSearchPlaceholder;
  var classes = useStyles();

  var renderSearch = function renderSearch() {
    if (!withSearch) {
      return null;
    }

    return React.createElement("div", {
      className: classes.search
    }, React.createElement("div", {
      className: classes.searchIcon
    }, React.createElement(SearchIcon, null)), React.createElement(InputBase, {
      placeholder: withSearchPlaceholder,
      classes: {
        root: classes.inputRoot,
        input: classes.inputInput
      },
      inputProps: {
        'aria-label': 'search'
      }
    }));
  };

  return React.createElement("div", {
    className: classes.root
  }, React.createElement(AppBar, {
    position: "fixed",
    classes: {
      root: clsx((_a = {}, _a[classes["default"]] = true, _a[classes.sidebarOpen] = sideBar && sideBarOpen, _a[classes.sidebarClosed] = sideBar && !sideBarOpen, _a))
    }
  }, React.createElement("div", {
    className: classes.offset
  }, React.createElement(Toolbar, null, React.createElement(Typography, {
    className: classes.title,
    variant: "h6",
    noWrap: true
  }, title), renderSearch(), (barItems || []).map(function (barItem) {
    return barItem;
  })))));
};

var AccountBarItem = function AccountBarItem(props) {
  var name = props.name,
      department = props.department;
  return React.createElement(IconButton, {
    "aria-label": "user account",
    color: "inherit"
  }, React.createElement(AccountCircle, null), React.createElement(Typography, {
    style: {
      textAlign: 'left',
      paddingLeft: '15px'
    },
    variant: "subtitle2"
  }, name, ' ', React.createElement("br", null), React.createElement(Typography, {
    variant: "body2"
  }, ' ', department, ' ')));
};

var FbButton = function FbButton(props) {
  var children = props.children;
  return React.createElement(Button, Object.assign({}, props), children);
};

var drawerWidth = 240;
var useStyles$1 =
/*#__PURE__*/
makeStyles(function (theme) {
  var _a;

  return {
    root: {
      display: 'flex'
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: "calc(100% - " + drawerWidth + "px)",
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    menuButton: {
      marginRight: 36
    },
    hide: {
      display: 'none'
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap'
    },
    drawerOpen: {
      width: drawerWidth,
      padding: '0px 20px',
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    drawerClose: (_a = {
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      overflowX: 'hidden',
      width: theme.spacing(7) + 1
    }, _a[theme.breakpoints.up('sm')] = {
      width: theme.spacing(9) + 1
    }, _a),
    drawerBackground: {
      '&::after': {
        content: '""',
        backgroundImage: 'url("https://straumannprod-h.assetsadobe2.com/is/image/content/dam/media-center/group/en/images/photography/sailing/Straumann_Group_Sailing_1.jpg?wid=1600")',
        backgroundSize: 'cover',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        position: 'absolute',
        zIndex: -1,
        opacity: 0.1,
        filter: 'grayscale(1)',
        backgroundPosition: 'center'
      }
    },
    listItem: {
      padding: '8px 23px'
    },
    control: __assign({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(0, 1)
    }, theme.mixins.toolbar),
    content: {
      flexGrow: 1,
      padding: theme.spacing(3)
    }
  };
});

var SideBarItem = function SideBarItem(props) {
  var classes = useStyles$1();
  var title = props.title,
      icon = props.icon,
      onClick = props.onClick;
  return React.createElement(ListItem, {
    button: true,
    key: "nav-" + title,
    className: classes.listItem,
    onClick: onClick
  }, React.createElement(ListItemIcon, null, icon), React.createElement(ListItemText, {
    primary: title
  }));
};

var SideBar = function SideBar(props) {
  var _a, _b;

  var isOpen = props.isOpen,
      children = props.children,
      onClickSidebarShrink = props.onClickSidebarShrink,
      onClickSidebarExpand = props.onClickSidebarExpand;
  var classes = useStyles$1();
  var theme = useTheme();

  var renderCorrespondingControlIcon = function renderCorrespondingControlIcon() {
    if (!onClickSidebarExpand || !onClickSidebarShrink) {
      return null;
    }

    if (isOpen) {
      return React.createElement(IconButton, {
        onClick: onClickSidebarShrink
      }, theme.direction === 'rtl' ? React.createElement(ChevronRightIcon, null) : React.createElement(ChevronLeftIcon, null));
    }

    return React.createElement(IconButton, {
      onClick: onClickSidebarExpand
    }, theme.direction === 'rtl' ? React.createElement(ChevronLeftIcon, null) : React.createElement(MenuIcon, null));
  };

  return React.createElement("div", {
    className: classes.root
  }, React.createElement(CssBaseline, null), React.createElement(Drawer, {
    variant: "permanent",
    className: clsx(classes.drawer, (_a = {}, _a[classes.drawerOpen] = isOpen, _a[classes.drawerClose] = !isOpen, _a)),
    classes: {
      paper: clsx((_b = {}, _b[classes.drawerOpen] = isOpen, _b[classes.drawerClose] = !isOpen, _b[classes.drawerBackground] = true, _b))
    },
    open: isOpen
  }, React.createElement("div", {
    className: classes.control
  }, renderCorrespondingControlIcon()), React.createElement(React.Fragment, null, React.createElement(Divider, null), React.createElement(List, null, children))));
};

var useStyles$2 =
/*#__PURE__*/
makeStyles(function (theme) {
  return {
    grid: {
      width: 'unset'
    },
    gridHeader: {
      marginTop: '64px !important',
      padding: theme.spacing(2)
    }
  };
});

var GridContainer = function GridContainer(props) {
  var _a;

  var classes = useStyles$2();

  var children = props.children,
      hasHeader = props.hasHeader,
      className = props.className,
      rest = __rest(props, ["children", "hasHeader", "className"]);

  var gridContainerClasses = classNames((_a = {}, _a[classes.grid] = true, _a[classes.gridHeader] = hasHeader, _a[className || ''] = className !== undefined, _a));
  return React.createElement(Grid, __assign({
    container: true
  }, rest, {
    className: gridContainerClasses
  }), children);
};

var styles = {
  grid: {
    padding: '0 15px !important'
  }
};
var useStyles$3 =
/*#__PURE__*/
makeStyles(styles);

var GridItem = function GridItem(props) {
  var classes = useStyles$3();
  var children = props.children,
      xs = props.xs,
      sm = props.sm,
      md = props.md;
  return React.createElement(Grid, {
    item: true,
    xs: xs,
    sm: sm,
    md: md,
    className: classes.grid
  }, children);
};
/* eslint-disable */
// // // Function that converts from hex color to rgb color
// // // Example: input = #9c27b0 => output = 156, 39, 176
// // // Example: input = 9c27b0 => output = 156, 39, 176
// // // Example: input = #999 => output = 153, 153, 153
// // // Example: input = 999 => output = 153, 153, 153
// #############################


var hexToRgb = function hexToRgb(input) {
  input += '';
  input = input.replace('#', '');
  var hexRegex = /[0-9A-Fa-f]/g;

  if (!hexRegex.test(input) || input.length !== 3 && input.length !== 6) {
    throw new Error('input is not a valid hex color.');
  }

  if (input.length === 3) {
    var first_1 = input[0];
    var second_1 = input[1];
    var last_1 = input[2];
    input = first_1 + first_1 + second_1 + second_1 + last_1 + last_1;
  }

  input = input.toUpperCase();
  var first = input[0] + input[1];
  var second = input[2] + input[3];
  var last = input[4] + input[5];
  return parseInt(first, 16) + ", " + parseInt(second, 16) + ", " + parseInt(last, 16);
}; // ##############################


var primaryColor = ['#467abd', '#467abd', '#467abd', '#467abd'];
var warningColor = ['#ff9800', '#ffa726', '#fb8c00', '#ffa21a'];
var dangerColor = ['#f44336', '#ef5350', '#e53935', '#f55a4e'];
var successColor = ['#4caf50', '#66bb6a', '#43a047', '#5cb860'];
var infoColor = ['#00acc1', '#26c6da', '#00acc1', '#00d3ee'];
var roseColor = ['#e91e63', '#ec407a', '#d81b60', '#eb3573'];
var grayColor = ['#999', '#777', '#3C4858', '#AAAAAA', '#D2D2D2', '#DDD', '#b4b4b4', '#555555', '#333', '#a9afbb', '#eee', '#e7e7e7'];
var blackColor = '#000';
var whiteColor = '#FFF';
var primaryBoxShadow = {
  boxShadow: "0 4px 20px 0 rgba(" +
  /*#__PURE__*/
  hexToRgb(blackColor) + ",.14), 0 7px 10px -5px rgba(" +
  /*#__PURE__*/
  hexToRgb(primaryColor[0]) + ",.4)"
};
var infoBoxShadow = {
  boxShadow: "0 4px 20px 0 rgba(" +
  /*#__PURE__*/
  hexToRgb(blackColor) + ",.14), 0 7px 10px -5px rgba(" +
  /*#__PURE__*/
  hexToRgb(infoColor[0]) + ",.4)"
};
var successBoxShadow = {
  boxShadow: "0 4px 20px 0 rgba(" +
  /*#__PURE__*/
  hexToRgb(blackColor) + ",.14), 0 7px 10px -5px rgba(" +
  /*#__PURE__*/
  hexToRgb(successColor[0]) + ",.4)"
};
var warningBoxShadow = {
  boxShadow: "0 4px 20px 0 rgba(" +
  /*#__PURE__*/
  hexToRgb(blackColor) + ",.14), 0 7px 10px -5px rgba(" +
  /*#__PURE__*/
  hexToRgb(warningColor[0]) + ",.4)"
};
var dangerBoxShadow = {
  boxShadow: "0 4px 20px 0 rgba(" +
  /*#__PURE__*/
  hexToRgb(blackColor) + ",.14), 0 7px 10px -5px rgba(" +
  /*#__PURE__*/
  hexToRgb(dangerColor[0]) + ",.4)"
};
var roseBoxShadow = {
  boxShadow: "0 4px 20px 0 rgba(" +
  /*#__PURE__*/
  hexToRgb(blackColor) + ",.14), 0 7px 10px -5px rgba(" +
  /*#__PURE__*/
  hexToRgb(roseColor[0]) + ",.4)"
};

var warningCardHeader =
/*#__PURE__*/
__assign({
  background: "linear-gradient(60deg, " + warningColor[1] + ", " + warningColor[2] + ")"
}, warningBoxShadow);

var successCardHeader =
/*#__PURE__*/
__assign({
  background: "linear-gradient(60deg, " + successColor[1] + ", " + successColor[2] + ")"
}, successBoxShadow);

var dangerCardHeader =
/*#__PURE__*/
__assign({
  background: "linear-gradient(60deg, " + dangerColor[1] + ", " + dangerColor[2] + ")"
}, dangerBoxShadow);

var infoCardHeader =
/*#__PURE__*/
__assign({
  background: "linear-gradient(60deg, " + infoColor[1] + ", " + infoColor[2] + ")"
}, infoBoxShadow);

var primaryCardHeader =
/*#__PURE__*/
__assign({
  background: "linear-gradient(60deg, " + primaryColor[1] + ", " + primaryColor[2] + ")"
}, primaryBoxShadow);

var roseCardHeader =
/*#__PURE__*/
__assign({
  background: "linear-gradient(60deg, " + roseColor[1] + ", " + roseColor[2] + ")"
}, roseBoxShadow);
/* eslint-enable */


var cardStyle = {
  card: {
    border: '0',
    marginBottom: '30px',
    marginTop: '30px',
    borderRadius: '6px',
    color: "rgba(" +
    /*#__PURE__*/
    hexToRgb(blackColor) + ", 0.87)",
    background: whiteColor,
    width: '100%',
    boxShadow: "0 1px 4px 0 rgba(" +
    /*#__PURE__*/
    hexToRgb(blackColor) + ", 0.14)",
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    wordWrap: 'break-word',
    fontSize: '.875rem',
    textAlign: 'right'
  },
  cardPlain: {
    background: 'transparent',
    boxShadow: 'none'
  },
  cardProfile: {
    marginTop: '30px',
    textAlign: 'center'
  },
  cardChart: {
    '& p': {
      marginTop: '0px',
      paddingTop: '0px'
    }
  }
};

var Card = function Card(props) {
  var _a;

  var classes = makeStyles(cardStyle)();

  var className = props.className,
      children = props.children,
      isPlain = props.isPlain,
      isProfile = props.isProfile,
      isChart = props.isChart,
      rest = __rest(props, ["className", "children", "isPlain", "isProfile", "isChart"]);

  var cardClasses = classNames((_a = {}, _a[classes.card] = true, _a[classes.cardPlain] = isPlain, _a[classes.cardProfile] = isProfile, _a[classes.cardChart] = isChart, _a[className || ''] = className !== undefined, _a));
  return React.createElement("div", __assign({
    className: cardClasses
  }, rest), children);
};

var cardBodyStyle = function cardBodyStyle(params) {
  return {
    cardBody: {
      padding: '0.7375rem 20px 0px 20px',
      flex: '1 1 auto',
      textAlign: params.align || 'left',
      WebkitBoxFlex: '1',
      position: 'relative'
    },
    cardBodyPlain: {
      paddingLeft: '20px',
      paddingRight: '20px',
      textAlign: params.align || 'left'
    },
    cardBodyProfile: {
      marginBottom: '15px',
      textAlign: params.align || 'left'
    }
  };
};

var cardTitleStyle = function cardTitleStyle(params) {
  return {
    cardTitle: {
      color: params.color && params.color[1] || grayColor[2],
      marginTop: '2px',
      textAlign: params.align || 'right',
      padding: params.padding || '0 10px',
      minHeight: 'auto',
      fontWeight: '300',
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      textDecoration: 'none',
      '& small': {
        color: params.color && params.color[0] || grayColor[1],
        fontWeight: '400',
        lineHeight: '1',
        fontSize: '50%'
      }
    }
  };
};

var CardTitle = function CardTitle(props) {
  var _a;

  var title = props.title,
      className = props.className,
      variant = props.variant,
      color = props.color,
      unit = props.unit,
      align = props.align,
      padding = props.padding;
  var baseColor = grayColor;

  if (color === 'white') {
    baseColor = [grayColor[3], whiteColor];
  } // @ts-ignore


  var useStyles = makeStyles(cardTitleStyle({
    color: baseColor,
    align: align,
    padding: padding
  }));
  var classes = useStyles();
  var cardTitleClasses = classNames((_a = {}, _a[classes.cardTitle] = true, _a[className || ''] = className !== undefined, _a));
  return React.createElement(Typography$1, {
    className: cardTitleClasses,
    variant: variant || 'h4'
  }, title, " ", React.createElement("small", null, unit));
};

var cardCategoryStyle = {
  cardCategory: {
    color: grayColor[0],
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    paddingTop: '10px',
    marginBottom: '0'
  }
};
var useStyles$4 =
/*#__PURE__*/
makeStyles(cardCategoryStyle);

var CardCategory = function CardCategory(props) {
  var _classNames;

  var classes = useStyles$4();
  var title = props.title,
      className = props.className,
      children = props.children;
  var cardHeaderClasses = classNames((_classNames = {}, _classNames[classes.cardCategory] = true, _classNames[className || ''] = className !== undefined, _classNames));

  if (title) {
    return React.createElement("div", {
      className: cardHeaderClasses
    }, React.createElement(Typography$1, {
      variant: "caption"
    }, title));
  }

  return React.createElement("div", {
    className: cardHeaderClasses
  }, children);
};

var useStyles$5 =
/*#__PURE__*/
makeStyles(cardBodyStyle);

var CardBody = function CardBody(props) {
  var _classNames;

  var classes = useStyles$5();
  var title = props.title,
      children = props.children,
      className = props.className,
      isPlain = props.isPlain,
      isProfile = props.isProfile,
      align = props.align;
  var cardBodyClasses = classNames((_classNames = {}, _classNames[classes.cardBody] = true, _classNames[classes.cardBodyPlain] = isPlain, _classNames[classes.cardBodyProfile] = isProfile, _classNames[className || ''] = className !== undefined, _classNames));
  return React.createElement("div", {
    className: cardBodyClasses
  }, function () {
    return title ? React.createElement(CardTitle, {
      align: align,
      variant: "h5",
      title: title,
      padding: "5px 10px 0xp 0px"
    }) : null;
  }(), function () {
    return children ? React.createElement(CardCategory, null, children) : null;
  }());
};

var cardFooterStyle = {
  cardFooter: {
    padding: '0',
    paddingTop: '10px',
    margin: '10px 15px',
    borderRadius: '0',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    backgroundColor: 'transparent',
    border: '0'
  },
  cardFooterProfile: {
    marginTop: '-15px'
  },
  cardFooterPlain: {
    paddingLeft: '5px',
    paddingRight: '5px',
    backgroundColor: 'transparent'
  },
  cardFooterBase: {
    borderTop: "1px solid " + grayColor[10],
    '& svg': {
      position: 'relative',
      top: '4px',
      marginRight: '3px',
      marginLeft: '3px',
      width: '16px',
      height: '16px'
    },
    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
      fontSize: '16px',
      position: 'relative',
      top: '4px',
      marginRight: '3px',
      marginLeft: '3px'
    }
  },
  cardFooterStats: {
    '&$cardFooterBase': {
      marginTop: '20px'
    }
  },
  cardFooterChart: {
    borderTop: "1px solid " + grayColor[10]
  }
};
var useStyles$6 =
/*#__PURE__*/
makeStyles(cardFooterStyle);

var CardFooter = function CardFooter(props) {
  var _a;

  var classes = useStyles$6();
  var children = props.children,
      className = props.className,
      isPlain = props.isPlain,
      isProfile = props.isProfile,
      isStats = props.isStats,
      isChart = props.isChart;
  var cardFooterClasses = classNames((_a = {}, _a[classes.cardFooter] = true, _a[classes.cardFooterBase] = true, _a[classes.cardFooterPlain] = isPlain, _a[classes.cardFooterProfile] = isProfile, _a[classes.cardFooterStats] = isStats, _a[classes.cardFooterChart] = isChart, _a[className || ''] = className !== undefined, _a));
  return React.createElement("div", {
    className: cardFooterClasses
  }, children);
};

var cardHeaderStyle = {
  cardHeader: {
    padding: '0.75rem 1.25rem',
    marginBottom: '0',
    borderBottom: 'none',
    background: 'transparent',
    zIndex: '!important',
    '&$cardHeaderPlain,&$cardHeaderIcon,&$cardHeaderStats,&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader': {
      margin: '0 15px',
      padding: '0',
      position: 'relative',
      color: whiteColor
    },
    '&:first-child': {
      borderRadius: 'calc(.25rem - 1px) calc(.25rem - 1px) 0 0'
    },
    '&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader': {
      '&:not($cardHeaderIcon)': {
        borderRadius: '3px',
        marginTop: '-20px',
        padding: '5px'
      }
    },
    '&$cardHeaderStats svg, &$cardHeaderBrick svg': {
      fontSize: '36px',
      lineHeight: '56px',
      textAlign: 'center',
      width: '36px',
      height: '36px',
      margin: '0px'
    },
    '&$cardHeaderStats i,&$cardHeaderStats .material-icons, &$cardHeaderBrick i,&$cardHeaderBrick .material-icons': {
      fontSize: '36px',
      lineHeight: '56px',
      width: '56px',
      height: '56px',
      textAlign: 'center',
      overflow: 'unset',
      marginBottom: '1px'
    },
    '&$cardHeaderStats$cardHeaderIcon, &$cardHeaderBrick$cardHeaderIcon': {
      textAlign: 'right'
    }
  },
  cardHeaderPlain: {
    marginLeft: '0px !important',
    marginRight: '0px !important'
  },
  cardHeaderBrick: {
    '& button': {
      marginTop: '15px'
    }
  },
  cardHeaderGeneric: {
    textAlign: 'left'
  },
  cardHeaderStats: {
    '& $cardHeaderIcon': {
      textAlign: 'right'
    }
  },
  cardHeaderIcon: {
    '&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader': {
      background: 'transparent',
      boxShadow: 'none'
    },
    '& i,& .material-icons': {
      width: '33px',
      height: '33px',
      textAlign: 'center',
      lineHeight: '33px'
    },
    '& svg': {
      width: '24px',
      height: '24px',
      textAlign: 'center',
      lineHeight: '33px',
      margin: '5px 4px 0px'
    }
  },
  warningCardHeader: {
    color: whiteColor,
    '&:not($cardHeaderIcon)':
    /*#__PURE__*/
    __assign({}, warningCardHeader)
  },
  successCardHeader: {
    color: whiteColor,
    '&:not($cardHeaderIcon)':
    /*#__PURE__*/
    __assign({}, successCardHeader)
  },
  dangerCardHeader: {
    color: whiteColor,
    '&:not($cardHeaderIcon)':
    /*#__PURE__*/
    __assign({}, dangerCardHeader)
  },
  infoCardHeader: {
    color: whiteColor,
    '&:not($cardHeaderIcon)':
    /*#__PURE__*/
    __assign({}, infoCardHeader)
  },
  primaryCardHeader: {
    color: whiteColor,
    '&:not($cardHeaderIcon)':
    /*#__PURE__*/
    __assign({}, primaryCardHeader)
  },
  roseCardHeader: {
    color: whiteColor,
    '&:not($cardHeaderIcon)':
    /*#__PURE__*/
    __assign({}, roseCardHeader)
  }
};
var useStyles$7 =
/*#__PURE__*/
makeStyles(cardHeaderStyle);

var CardHeader = function CardHeader(props) {
  var _a;

  var classes = useStyles$7();

  var className = props.className,
      children = props.children,
      color = props.color,
      isPlain = props.isPlain,
      isStats = props.isStats,
      hasIcon = props.hasIcon,
      type = props.type,
      rest = __rest(props, ["className", "children", "color", "isPlain", "isStats", "hasIcon", "type"]);

  var cardHeaderClasses = classNames((_a = {}, _a[classes.cardHeader] = true, _a[classes[color + "CardHeader"]] = color, _a[classes.cardHeaderPlain] = isPlain, _a[classes.cardHeaderStats] = isStats, _a[classes.cardHeaderIcon] = hasIcon, _a[classes.cardHeaderBrick] = type === 'brick', _a[className || ''] = className !== undefined, _a));
  return React.createElement("div", __assign({
    className: cardHeaderClasses
  }, rest), children);
};

var cardIconStyle = {
  cardIcon: {
    '&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader': {
      borderRadius: '3px',
      backgroundColor: grayColor[0],
      padding: '15px',
      marginTop: '-20px',
      marginRight: '15px',
      "float": 'left'
    }
  },
  warningCardHeader: warningCardHeader,
  successCardHeader: successCardHeader,
  dangerCardHeader: dangerCardHeader,
  infoCardHeader: infoCardHeader,
  primaryCardHeader: primaryCardHeader,
  roseCardHeader: roseCardHeader
};
var useStyles$8 =
/*#__PURE__*/
makeStyles(cardIconStyle);

var CardIcon = function CardIcon(props) {
  var _a;

  var classes = useStyles$8();

  var className = props.className,
      children = props.children,
      color = props.color,
      rest = __rest(props, ["className", "children", "color"]);

  var cardIconClasses = classNames((_a = {}, _a[classes.cardIcon] = true, _a[classes[color + "CardHeader"]] = color, _a[className || ''] = className !== undefined, _a));
  return React.createElement("div", __assign({
    className: cardIconClasses
  }, rest), children);
};

var tableStyle = function tableStyle() {
  return {
    root: {
      width: '100%'
    },
    container: {
      maxHeight: 540
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1
    },
    test: {
      backgroundColor: 'red !important',
      '&:hover': {
        cursor: 'pointer'
      }
    }
  };
};

var StyledTableRow =
/*#__PURE__*/
withStyles({
  root: {
    '&:hover': {
      cursor: 'pointer'
    }
  }
})(TableRow);
var useStyles$9 =
/*#__PURE__*/
makeStyles(tableStyle); // @ts-ignore

function FbTable(props) {
  var classes = useStyles$9();
  var columns = props.columns || [];
  var rows = props.rows || [];
  var pagination = props.pagination;

  var renderSort = function renderSort(cell) {
    if (!cell.sort) {
      return cell.renderHeaderLabel ? cell.renderHeaderLabel(cell.label) : cell.label;
    }

    return React.createElement(TableSortLabel, {
      active: get(cell, 'sort.active', false),
      direction: get(cell, 'sort.direction', 'asc'),
      onClick: get(cell, 'sort.onClick', function () {})
    }, cell.renderHeaderLabel ? cell.renderHeaderLabel(cell.label) : cell.label, get(cell, 'sort.active', false) ? React.createElement("span", {
      className: classes.visuallyHidden
    }, get(cell, 'sort.direction', 'desc') === 'desc' ? 'sorted descending' : 'sorted ascending') : null);
  };

  var renderPagination = function renderPagination() {
    if (!pagination) {
      return null;
    }

    return React.createElement(TablePagination, {
      rowsPerPageOptions: get(pagination, 'rowsPerPageOptions', [5, 10, 25]),
      component: "div",
      count: get(pagination, 'count', -1),
      rowsPerPage: get(pagination, 'rowsPerPage', -1),
      page: get(pagination, 'currentPage', -1),
      onChangePage: get(pagination, 'onChangePage', function () {}),
      onChangeRowsPerPage: get(pagination, 'onChangeRowsPerPage', function () {})
    });
  };

  return React.createElement("div", {
    className: classes.tableResponsive
  }, React.createElement(Paper, {
    className: classes.root
  }, React.createElement(TableContainer, {
    className: classes.container
  }, React.createElement(Table, {
    className: classes.table,
    stickyHeader: true,
    "aria-label": "sticky table"
  }, React.createElement(TableHead, null, React.createElement(TableRow, null, columns.map(function (cell) {
    return React.createElement(TableCell, {
      key: cell.id,
      align: cell.align,
      style: {
        minWidth: cell.minWidth
      }
    }, renderSort(cell));
  }))), React.createElement(TableBody, null, rows.map(function (row) {
    return React.createElement(StyledTableRow, {
      hover: true,
      role: "checkbox",
      tabIndex: -1,
      key: row.id,
      onClick: function onClick() {
        return props.onRowClick ? props.onRowClick(row.uuid) : {};
      }
    }, columns.map(function (column) {
      var value = row[column.id];
      return React.createElement(TableCell, {
        key: column.id,
        align: column.align
      }, column.renderValue ? column.renderValue(value) : value);
    }));
  })))), renderPagination()));
}

FbTable.defaultProps = {
  tableHeaderColor: 'gray',
  hover: false,
  colorsColls: [],
  coloredColls: [],
  striped: false,
  customCellClasses: [],
  customClassesForCells: [],
  customHeadCellClasses: [],
  customHeadClassesForCells: []
};
FbTable.propTypes = {
  tableHeaderColor:
  /*#__PURE__*/
  PropTypes.oneOf(['warning', 'primary', 'danger', 'success', 'info', 'rose', 'gray']),
  tableHead:
  /*#__PURE__*/
  PropTypes.arrayOf(PropTypes.string),
  // Of(PropTypes.arrayOf(PropTypes.node)) || Of(PropTypes.object),
  tableData: PropTypes.array,
  hover: PropTypes.bool,
  coloredColls:
  /*#__PURE__*/
  PropTypes.arrayOf(PropTypes.number),
  // Of(["warning","primary","danger","success","info","rose","gray"]) - colorsColls
  colorsColls: PropTypes.array,
  customCellClasses:
  /*#__PURE__*/
  PropTypes.arrayOf(PropTypes.string),
  customClassesForCells:
  /*#__PURE__*/
  PropTypes.arrayOf(PropTypes.number),
  customHeadCellClasses:
  /*#__PURE__*/
  PropTypes.arrayOf(PropTypes.string),
  customHeadClassesForCells:
  /*#__PURE__*/
  PropTypes.arrayOf(PropTypes.number),
  striped: PropTypes.bool,
  // this will cause some changes in font
  tableShopping: PropTypes.bool
};

var FbCheckbox = function FbCheckbox(props) {
  var icon = props.icon,
      disabled = props.disabled,
      checkedIcon = props.checkedIcon,
      value = props.value,
      label = props.label,
      color = props.color,
      indeterminate = props.indeterminate,
      size = props.size,
      onChange = props.onChange,
      id = props.id,
      checked = props.checked;
  return React.createElement(FormControlLabel, {
    disabled: disabled === true,
    control: React.createElement(Checkbox, {
      id: id,
      icon: icon,
      checked: checked === true,
      onChange: onChange,
      checkedIcon: checkedIcon,
      value: value,
      color: color,
      size: size,
      indeterminate: indeterminate === true
    }),
    label: label
  });
};

var FbSelectItem = function FbSelectItem(props) {
  var value = props.value,
      labelValue = props.labelValue;
  return React.createElement(MenuItem, {
    value: value
  }, labelValue);
};

var useStyles$a =
/*#__PURE__*/
makeStyles$1(function (theme) {
  return createStyles$1({
    formControl: {
      minWidth: 120,
      marginBottom: theme.spacing(2)
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    }
  });
});

var FbSelect = function FbSelect(props) {
  var classes = useStyles$a();
  var onChange = props.onChange,
      value = props.value,
      label = props.label,
      id = props.id,
      options = props.options,
      disabled = props.disabled,
      noselection = props.noselection;

  if (noselection) {
    options.unshift({
      label: noselection,
      value: ''
    });
  }

  var renderedItems = options.map(function (option) {
    return React.createElement(MenuItem, {
      value: option.value
    }, option.label, " ");
  });
  return React.createElement(FormControl, {
    className: classes.formControl,
    fullWidth: true,
    disabled: disabled === true
  }, React.createElement(InputLabel, {
    id: id + "-label"
  }, label), React.createElement(Select, {
    labelId: id + "-label",
    fullWidth: true,
    id: id,
    value: value,
    onChange: onChange
  }, renderedItems));
};

var useStyles$b =
/*#__PURE__*/
makeStyles$1(function (theme) {
  return createStyles$1({
    formControl: {
      marginBottom: theme.spacing(2)
    }
  });
});

var FbInput = function FbInput(props) {
  var disabled = props.disabled;
  var classes = useStyles$b();
  return React.createElement(FormControl, {
    className: classes.formControl,
    fullWidth: true,
    disabled: disabled === true
  }, React.createElement(TextField, {
    label: props.label,
    id: props.id,
    defaultValue: props.defaultValue,
    value: props.value,
    className: props.className,
    helperText: props.helperText,
    variant: props.variant,
    type: props.type,
    name: props.name,
    size: props.size,
    onChange: props.onChange
  }));
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var useStyles$c = function useStyles(params) {
  return makeStyles$1({
    root: {
      height: params.height || 5
    }
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var color = props.color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      variant = props.variant,
      styles = props.styles;
  var classes = useStyles$c(styles || {})();
  return React.createElement(LinearProgress, {
    classes: _extends({}, classes),
    color: color,
    value: value,
    valueBuffer: valueBuffer,
    variant: variant
  });
}; // @ts-ignore


var FbSlider = function FbSlider(props) {
  var color = props.color,
      value = props.value,
      valueText = props.valueText,
      valueLabelFormat = props.valueLabelFormat,
      min = props.min,
      max = props.max,
      step = props.step,
      defaultValue = props.defaultValue,
      showValueLabel = props.showValueLabel,
      disabled = props.disabled,
      marks = props.marks,
      onChange = props.onChange,
      onChangeCommitted = props.onChangeCommitted;
  return React.createElement(Slider, {
    color: color,
    step: step,
    disabled: disabled,
    defaultValue: defaultValue,
    value: value,
    marks: marks,
    min: min,
    max: max,
    onChange: onChange,
    getAriaValueText: valueText,
    valueLabelFormat: valueLabelFormat,
    onChangeCommitted: onChangeCommitted,
    valueLabelDisplay: showValueLabel
  });
};

var components = {
  BarLoader: BarLoader,
  BeatLoader: BeatLoader,
  GridLoader: GridLoader,
  BounceLoader: BounceLoader,
  HashLoader: HashLoader
};

var Spinner = function Spinner(props) {
  var type = props.type,
      isLoading = props.isLoading,
      css = props.css,
      size = props.size,
      color = props.color;
  var SpecificSpinner = components[type];
  return React.createElement("div", {
    className: "sweet-loading"
  }, React.createElement(SpecificSpinner, {
    css: css,
    size: size,
    color: color,
    loading: isLoading
  }));
};

var useStyles$d =
/*#__PURE__*/
makeStyles$2(function (theme) {
  return createStyles$1({
    formControl: {
      marginBottom: theme.spacing(2)
    }
  });
});

function fieldToCheckbox(_ref) {
  var disabled = _ref.disabled,
      field = _ref.field,
      isSubmitting = _ref.form.isSubmitting,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, ["disabled", "field", "form", "type"]);

  var indeterminate = !Array.isArray(field.value) && field.value == null;

  if (process.env.NODE_ENV !== 'production') {
    if (type === 'checkbox') {
      console.error("property type=checkbox is missing from field " + field.name + ", this can caused unexpected behaviour");
    }
  }

  return _extends({
    disabled: disabled ? disabled : isSubmitting,
    checked: field.value,
    indeterminate: indeterminate
  }, props, {}, field);
}

var FbFormikCheckbox = function FbFormikCheckbox(props) {
  var label = props.label,
      disabled = props.disabled;
  var classes = useStyles$d();
  return React.createElement(FormControl, {
    className: classes.formControl,
    fullWidth: true
  }, React.createElement(FormControlLabel, {
    disabled: disabled === true,
    control: React.createElement(Checkbox, Object.assign({}, fieldToCheckbox(props))),
    label: label
  }));
};

var useStyles$e =
/*#__PURE__*/
makeStyles$1(function (theme) {
  return createStyles$1({
    formControl: {
      minWidth: 120,
      marginBottom: theme.spacing(2)
    },
    selectEmpty: {
      marginTop: theme.spacing(1)
    }
  });
});

function fieldToSelect(_ref) {
  var disabled = _ref.disabled,
      field = _ref.field,
      isSubmitting = _ref.form.isSubmitting,
      props = _objectWithoutPropertiesLoose(_ref, ["disabled", "field", "form"]);

  return _extends({
    disabled: disabled ? disabled : isSubmitting
  }, props, {}, field);
}

var FbFormikSelect = function FbFormikSelect(props) {
  var classes = useStyles$e();
  var noselection = props.noselection,
      id = props.id,
      options = props.options,
      disabled = props.disabled,
      label = props.label,
      field = props.field,
      meta = props.meta;
  var renderedItems = (options || []).map(function (option, index) {
    return React.createElement(MenuItem, {
      key: field.name + "-" + index,
      value: option.value
    }, option.label);
  });
  var showError = meta.error !== undefined && meta.touched;
  var usedHelperMessage = showError ? meta.error : undefined;

  var renderHelperMessage = function renderHelperMessage() {
    if (showError) {
      return React.createElement(FormHelperText, null, usedHelperMessage);
    }

    return null;
  };

  var renderNoSelection = function renderNoSelection() {
    if (noselection) {
      return React.createElement(MenuItem, {
        key: field.name + "-no-selection",
        value: ""
      }, noselection);
    }

    return null;
  };

  return React.createElement(FormControl, {
    className: classes.formControl,
    fullWidth: true,
    disabled: disabled === true,
    error: showError
  }, React.createElement(InputLabel, {
    id: id + "-label"
  }, label), React.createElement(Select, Object.assign({}, fieldToSelect(props)), renderNoSelection(), renderedItems), renderHelperMessage());
};

var useStyles$f =
/*#__PURE__*/
makeStyles$1(function (theme) {
  return createStyles$1({
    formControl: {
      marginBottom: theme.spacing(2)
    }
  });
});

function fieldToTextField(_ref) {
  var disabled = _ref.disabled,
      field = _ref.field,
      _ref$form = _ref.form,
      isSubmitting = _ref$form.isSubmitting,
      touched = _ref$form.touched,
      errors = _ref$form.errors,
      props = _objectWithoutPropertiesLoose(_ref, ["disabled", "field", "form"]);

  var fieldError = getIn(errors, field.name);
  var showError = getIn(touched, field.name) && !!fieldError;

  if (!isSubmitting) {
    isSubmitting = false;
  }

  return _extends({}, props, {}, field, {
    error: showError,
    helperText: showError ? fieldError : props.helperText,
    disabled: disabled ? disabled : isSubmitting,
    variant: props.variant
  });
}

var FbFormikTextField = function FbFormikTextField(props) {
  var classes = useStyles$f();
  return React.createElement(FormControl, {
    className: classes.formControl,
    fullWidth: true
  }, React.createElement(TextField, Object.assign({}, fieldToTextField(props))));
};

var FbTab = function FbTab(props) {
  return React.createElement(Tab, Object.assign({}, props));
};

var FbTabs = function FbTabs(props) {
  var activeTabIndex = props.activeTabIndex,
      children = props.children,
      willChangeTab = props.willChangeTab,
      didChangeTab = props.didChangeTab,
      otherProps = _objectWithoutPropertiesLoose(props, ["activeTabIndex", "children", "willChangeTab", "didChangeTab"]);

  var _React$useState = React.useState(activeTabIndex || 0),
      value = _React$useState[0],
      setValue = _React$useState[1];

  var handleChange = function handleChange(_event, newValue) {
    if (willChangeTab) {
      willChangeTab(newValue);
    }

    setValue(newValue);

    if (didChangeTab) {
      didChangeTab(newValue);
    }
  };

  return React.createElement(Tabs, Object.assign({}, otherProps, {
    value: value,
    onChange: handleChange
  }), children);
};

var FbPaper = function FbPaper(props) {
  return React.createElement(Paper, Object.assign({}, props));
};

var BarItems = {
  account: AccountBarItem
};
export { StyledAppBar as AppBar, BarItems, BaseTheme, Card, CardBody, CardCategory, CardFooter, CardHeader, CardIcon, CardTitle, FbButton, FbCheckbox, FbFormikCheckbox, FbFormikSelect, FbFormikTextField, FbInput, FbPaper, FbSelect, FbSelectItem, FbTab, FbTabs, GridContainer, GridItem, LoadingIndicator, SideBar, SideBarItem, FbSlider as Slider, Spinner, FbTable as Table, FbThemeProvider as ThemeProvider };